import { render, staticRenderFns } from "./PublishTestStudent.vue?vue&type=template&id=6fb3c5d2&scoped=true"
import script from "./PublishTestStudent.vue?vue&type=script&lang=js"
export * from "./PublishTestStudent.vue?vue&type=script&lang=js"
import style0 from "./PublishTestStudent.vue?vue&type=style&index=0&id=6fb3c5d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb3c5d2",
  null
  
)

export default component.exports